import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import NewSoundtrailScreen from './NewSoundtrailScreen'
import Popup from "reactjs-popup";


const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        height: 100,
        width: 300,
        justifyContent: 'left',
    },
    cover: {
        width: 100,
        height: 100,
    },
}));


const NewSoundtrailCard = props => {
    const classes = useStyles();
    const [openCard, setOpenCard] = React.useState(false)
    return (
        <Card className={classes.root} style={props.style}>
            <Popup
                open={openCard}
                modal
                onClose={() => { setOpenCard(false); props.onClose(); }}
                closeOnDocumentClick={false}
                contentStyle={{ border: "none", width: "0px", padding: "0px" }}
            >
                <NewSoundtrailScreen onClose={() => { setOpenCard(false); props.onClose(); }} />
            </Popup>
            <CardActionArea className={classes.root} onClick={() => { setOpenCard(true) }}>
                <CardMedia
                    image={"https://cdn4.iconfinder.com/data/icons/files-and-folders-thinline-icons-set/144/File_Add-512.png"}
                    className={classes.cover}
                />
                <CardContent>
                    <Typography variant="h5" component="h2">
                        New Soundtrail
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

export default NewSoundtrailCard;